import clsx from 'clsx';
import LandscapeIcon from '../../assets/landscape-overlay.svg';
import LandscapeBg from '../../assets/bg-landscape-overlay.svg'

type LandscapeOverlayProps = {
    className?: string;
};
export function LandscapeOverlay(props: LandscapeOverlayProps) {
    return (
        <div
            className={clsx(
                'absolute z-[1001] inset-0 bg-white w-[100dvw] h-full flex flex-col justify-center items-center bg-cover bg-no-repeat bg-center',
                props.className,
            )}
            style={{
                backgroundImage: `url(${LandscapeBg})`,
            }}
        >
            <img src={LandscapeIcon} />
            <p className="text-xl font-light text-black pt-2">This experience is best viewed in portrait mode</p>
        </div>
    );
}
